module.exports = __webpack_public_path__ + "static/media/invoice.95c23018.svg";